import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/user";
import headerReducer from "./slices/header";
import customerReducer from "./slices/customer";
import advanceFilterReducer from "./slices/advance_filter";
import fileManagerReducer from "./slices/file_manager";
import themeReducer from "./slices/theme";
import { themeSyncMiddleware } from "./middleware/themeSync";

export const store = configureStore({
  reducer: {
    user: userReducer,
    customer: customerReducer,
    header: headerReducer,
    advanceFilter: advanceFilterReducer,
    fileManager: fileManagerReducer,
    theme: themeReducer,
  },
  
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(themeSyncMiddleware)
})
